import { render, staticRenderFns } from "./ol-point-video.vue?vue&type=template&id=918e935a&scoped=true&"
import script from "./ol-point-video.vue?vue&type=script&lang=js&"
export * from "./ol-point-video.vue?vue&type=script&lang=js&"
import style0 from "./ol-point-video.vue?vue&type=style&index=0&id=918e935a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "918e935a",
  null
  
)

export default component.exports